export const FETCH_USER_PRIVILEGES_REQUEST = 'FETCH_USER_PRIVILEGES_REQUEST';
export const FETCH_USER_PRIVILEGES_SUCCESS = 'FETCH_USER_PRIVILEGES_SUCCESS';
export const FETCH_USER_PRIVILEGES_FAILED = 'FETCH_USER_PRIVILEGES_FAILED';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILED = 'CREATE_USER_FAILED';

export const FETCH_USER_ORGANIZATIONS_REQUEST = 'FETCH_USER_ORGANIZATIONS_REQUEST';
export const FETCH_USER_ORGANIZATIONS_SUCCESS = 'FETCH_USER_ORGANIZATIONS_SUCCESS';
export const FETCH_USER_ORGANIZATIONS_FAILED = 'FETCH_USER_ORGANIZATIONS_FAILED';

export const RESET_CREATE_USER_SUCCESS = 'RESET_CREATE_USER_SUCCESS';
